import { errorNotification, successNotification } from '../../../constants/Toast';
import AI_REDUX_CONSTANT from '../../constants/aiReduxConstant/AIReduxConstant';
import AIStrategyService from '../../../services/ai-strategy-service/AIStrategyService';

/**
 * Generate personas using AI
 */
export const generatePersonas = (businessContext) => {
    return (dispatch) => {
        dispatch({
            type: AI_REDUX_CONSTANT.SET_GENERATING_PERSONAS,
            data: true,
        });

        AIStrategyService.generatePersonas(businessContext)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    // Map strategyId to _id for frontend compatibility
                    const strategyData = {
                        ...response.data.data,
                        _id: response.data.data.strategyId,
                    };

                    dispatch({
                        type: AI_REDUX_CONSTANT.SET_CURRENT_STRATEGY,
                        data: strategyData,
                    });
                    dispatch({
                        type: AI_REDUX_CONSTANT.SET_GENERATING_PERSONAS,
                        data: false,
                    });
                    successNotification(`Generated ${response.data.data.personaCount} personas successfully!`);
                }
            })
            .catch((e) => {
                dispatch({
                    type: AI_REDUX_CONSTANT.SET_GENERATING_PERSONAS,
                    data: false,
                });
                dispatch({
                    type: AI_REDUX_CONSTANT.SET_PERSONAS_ERROR,
                    data: e?.response?.data?.message || 'Failed to generate personas',
                });

                if (e?.response?.data?.status === 'FEATURE_DISABLED') {
                    errorNotification('AI Strategy Builder feature is not enabled');
                } else if (e?.response?.data?.message) {
                    errorNotification(e.response.data.message);
                } else {
                    errorNotification('Failed to generate personas. Please try again.');
                }
            });
    };
};

/**
 * Fetch all strategies
 */
export const fetchStrategies = (activeOnly = false) => {
    return (dispatch) => {
        AIStrategyService.getStrategies(activeOnly)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    dispatch({
                        type: AI_REDUX_CONSTANT.SET_STRATEGIES,
                        data: response.data.data,
                    });
                }
            })
            .catch((e) => {
                if (e?.response?.data?.message) {
                    errorNotification(e.response.data.message);
                } else {
                    errorNotification('Failed to fetch strategies');
                }
            });
    };
};

/**
 * Fetch single strategy
 */
export const fetchStrategy = (id) => {
    return (dispatch) => {
        AIStrategyService.getStrategy(id)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    dispatch({
                        type: AI_REDUX_CONSTANT.SET_CURRENT_STRATEGY,
                        data: response.data.data,
                    });
                }
            })
            .catch((e) => {
                if (e?.response?.data?.message) {
                    errorNotification(e.response.data.message);
                } else {
                    errorNotification('Failed to fetch strategy');
                }
            });
    };
};

/**
 * Update strategy
 */
export const updateStrategy = (id, data) => {
    return (dispatch) => {
        AIStrategyService.updateStrategy(id, data)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    dispatch({
                        type: AI_REDUX_CONSTANT.UPDATE_STRATEGY,
                        data: response.data.data,
                    });
                    successNotification('Strategy updated successfully');
                }
            })
            .catch((e) => {
                if (e?.response?.data?.message) {
                    errorNotification(e.response.data.message);
                } else {
                    errorNotification('Failed to update strategy');
                }
            });
    };
};

/**
 * Delete strategy
 */
export const deleteStrategy = (id) => {
    return (dispatch) => {
        AIStrategyService.deleteStrategy(id)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    dispatch({
                        type: AI_REDUX_CONSTANT.DELETE_STRATEGY,
                        data: id,
                    });
                    successNotification('Strategy deleted successfully');
                }
            })
            .catch((e) => {
                if (e?.response?.data?.message) {
                    errorNotification(e.response.data.message);
                } else {
                    errorNotification('Failed to delete strategy');
                }
            });
    };
};

/**
 * Activate strategy
 */
export const activateStrategy = (id) => {
    return (dispatch) => {
        AIStrategyService.activateStrategy(id)
            .then((response) => {
                if (response?.data?.status === 'SUCCESS') {
                    dispatch(fetchStrategies()); // Refresh list
                    successNotification('Strategy activated successfully');
                }
            })
            .catch((e) => {
                if (e?.response?.data?.message) {
                    errorNotification(e.response.data.message);
                } else {
                    errorNotification('Failed to activate strategy');
                }
            });
    };
};
